import { ComponentType } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserContext } from '@shared/contexts/UserContextProvider';
import PageLoadProgress from '@shared/components/PageLoadProgress';
import { checkIsFreemiumUser } from '@utils/permissions';

interface Props {
  component: ComponentType<object>;
}

export const FreemiumRouteGuard = ({ component }: Props) => {
  const user = useUserContext();
  const location = useLocation();

  const isFreemiumUser = checkIsFreemiumUser(user);

  if (!user) {
    return <PageLoadProgress />;
  }

  if (isFreemiumUser && !isFreemiumAllowedRoute(location.pathname)) {
    return <Navigate to="/freemium-news" replace />;
  }

  const Component = component;
  return <Component />;
};

const isFreemiumAllowedRoute = (pathname: string): boolean => {
  const allowedRoutes = ['/freemium-news', '/manage-account'];

  return allowedRoutes.includes(pathname);
};
